const logo = "/assets/catalyst7-brand-white-20260920.png";
const groups = [
  {
    title: "Studio",
    links: [
      { label: "Services", href: "/#services" },
      { label: "Work", href: "/#work" },
      { label: "About", href: "/#about" },
      { label: "Careers", href: "/careers" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Contact", href: "/#contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-line px-6 py-16 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a href="/" className="inline-flex items-center" aria-label="Catalyst home">
              <img src={logo} alt="Catalyst" className="h-9 w-auto" />
            </a>
            <p className="mt-4 text-sm leading-relaxed text-[#8C8C8C]">
              An editor-led AI filmmaking and post-production studio for films,
              narrative series and advertising.
            </p>
          </div>

          <div className="flex gap-16">
            {groups.map((g) => (
              <div key={g.title}>
                <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink/60">{g.title}</p>
                <ul className="mt-4 flex flex-col gap-3">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        data-testid={`footer-link-${l.label.toLowerCase()}`}
                        className="text-sm text-ink/80 transition-colors hover:text-accent"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-line pt-8 text-sm text-[#8C8C8C] sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Catalyst 7. All rights reserved.</p>
          <p>Web Design by Ragul</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
